import { render, staticRenderFns } from "./RenewalSummary.vue?vue&type=template&id=27374f64&scoped=true"
import script from "./RenewalSummary.vue?vue&type=script&lang=js"
export * from "./RenewalSummary.vue?vue&type=script&lang=js"
import style0 from "./RenewalSummary.vue?vue&type=style&index=0&id=27374f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27374f64",
  null
  
)

export default component.exports